import { render, staticRenderFns } from "./TestPrepSetCard.vue?vue&type=template&id=4edc5d6f&scoped=true&"
import script from "./TestPrepSetCard.vue?vue&type=script&lang=js&"
export * from "./TestPrepSetCard.vue?vue&type=script&lang=js&"
import style0 from "./TestPrepSetCard.vue?vue&type=style&index=0&id=4edc5d6f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edc5d6f",
  null
  
)

export default component.exports